import http from "utils/http";
import { frfDatabase } from "constants/endpoints";

const getFrfDataByMachineId = ({ machineId }) => {
  const POST_USER_ENDPOINT = frfDatabase.getFrfDataByMachineId({ machineId });
  const { REACT_APP_API_BASE_URL: API_BASE_URL } = process.env;
  return http.get(`${API_BASE_URL}${POST_USER_ENDPOINT}`);
};

export default getFrfDataByMachineId;
